/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react';
import styles from './NewBalju.module.scss';
import {Button, Modal} from "antd";
import {createBaljuAPI} from "../../../api/baechaAPI";
import {useBaechaList2Store} from "../../../stores/baechaList2Store";
import {useAppStore} from "../../../stores/appStore";
import MakeBaechaForm from "./MakeBaechaForm/MakeBaechaForm";
import BaljuDTO from "../../BaechaList/MakeBaecha/dto/BaljuDTO";

const NewBalju = () => {
	const setShouldShowSpinner = useAppStore((s) => s.setShouldShowSpinner);
	const fetch = useBaechaList2Store((s) => s.fetch);

	const [showModal, setShowModal] = useState(false);

	return (
		<div className={styles.wrap}>
			<Button
				onClick={() => setShowModal(true)}
				type="primary"
				shape="round"
			>
				+ 발주하기
			</Button>

			<Modal
				title="신규 배차"
				open={showModal}
				onCancel={() => setShowModal(false)}
				destroyOnClose
				footer={null}
				style={{ top: 10 }}
			>
				<MakeBaechaForm
					onSubmit={async (baljuDTO: BaljuDTO) => {
						try {
							setShouldShowSpinner(true);
							await createBaljuAPI(baljuDTO);
							await fetch();
						} catch(e) {
						  console.error(e);
						} finally {
							setShouldShowSpinner(false);
							setShowModal(false);
						}
					}}
					onCancel={() => setShowModal(false)}
				/>
			</Modal>
		</div>
	);
};

export default NewBalju;
